export enum Allergies {
  nuts = "nuts",
  dairy = "dairy",
  vegan = "vegan",
  vegetarian = "vegetarian",
  fish = "fish",
  veal = "veal",
  pork = "pork"
}

export enum AppNotificationType {
  news = "news",
  ad = "ad",
  version_update = "version_update"
}

export enum AuditActions {
  create_booking = "create_booking",
  update_booking = "update_booking",
  create_order = "create_order",
  order_items = "order_items",
  update_price = "update_price",
  create_item_discount = "create_item_discount",
  create_order_discount = "create_order_discount",
  update_item_discount = "update_item_discount",
  update_order_discount = "update_order_discount",
  remove_item_discount = "remove_item_discount",
  remove_order_discount = "remove_order_discount",
  add_item_to_order = "add_item_to_order",
  send_booking_message_to_guest = "send_booking_message_to_guest",
  create_product = "create_product",
  update_product = "update_product",
  delete_product = "delete_product",
  create_product_category = "create_product_category",
  update_product_category = "update_product_category",
  delete_product_category = "delete_product_category",
  create_employee = "create_employee",
  update_employee = "update_employee",
  delete_employee = "delete_employee"
}

export enum BookingAuditMessage {
  booking_confirmed = "booking_confirmed",
  booking_canceled = "booking_canceled",
  booking_modified = "booking_modified",
  custom = "custom",
  booking_reminder = "booking_reminder",
  review = "review"
}

export enum BookingAuditSource {
  widget = "widget",
  external = "external",
  pos = "pos",
  google_reserve = "google_reserve"
}

export enum BookingAuditTypes {
  group_size = "group_size",
  first_name = "first_name",
  last_name = "last_name",
  start_time = "start_time",
  end_time = "end_time",
  internal_memo = "internal_memo",
  status = "status",
  table = "table",
  phone_number = "phone_number",
  email = "email",
  created = "created"
}

export enum BookingEditType {
  create = "create",
  update = "update",
  delete = "delete",
  notification = "notification"
}

export enum BookingPlatformStatus {
  claimed = "claimed",
  unclaimed = "unclaimed",
  removed_by_owner = "removed_by_owner",
  removed_by_staff = "removed_by_staff"
}

export enum BookingStatus {
  active = "active",
  pending = "pending",
  canceled = "canceled",
  hold = "hold",
  expired = "expired",
  no_show = "no_show",
  checked_in = "checked_in",
  checked_out = "checked_out"
}

export enum ButtonLocations {
  cash_register_footer = "cash_register_footer",
  floor_plan_footer = "floor_plan_footer",
  cash_register_side = "cash_register_side",
  floor_plan_side = "floor_plan_side"
}

export enum CardAudience {
  consumer = "consumer",
  business = "business"
}

export enum CardFunding {
  credit = "credit",
  debit = "debit"
}

export enum CardReadMethods {
  "integrated-circuit-card" = "integrated-circuit-card",
  "magnetic-stripe-reader" = "magnetic-stripe-reader",
  "near-field-communication" = "near-field-communication",
  contactless = "contactless",
  manual = "manual"
}

export enum CardRegion {
  maestro = "maestro",
  "v-pay" = "v-pay",
  domestic = "domestic",
  "intra-eu" = "intra-eu",
  inter = "inter"
}

export enum CardVerificationMethods {
  "no-cvm-required" = "no-cvm-required",
  "online-pin" = "online-pin",
  signature = "signature",
  "signature-and-online-pin" = "signature-and-online-pin",
  "online-pin-and-signature" = "online-pin-and-signature",
  none = "none",
  failed = "failed"
}

export enum CashLocationMutationCategoryType {
  tip_from_cash = "tip_from_cash",
  tip_from_card_transactions = "tip_from_card_transactions",
  other = "other",
  difference = "difference",
  evaluation = "evaluation"
}

export enum CashLocationMutationType {
  in = "in",
  out = "out",
  evaluation = "evaluation",
  open_drawer = "open_drawer",
  deposit = "deposit"
}

export enum CashLocationReportType {
  open = "open",
  close = "close"
}

export enum CashLocationType {
  drawer = "drawer",
  employee = "employee",
  safe = "safe",
  bank = "bank"
}

export enum CashRegisterTableViews {
  floor_plan = "floor_plan",
  grid = "grid"
}

export enum ClockTypes {
  military = "military",
  regular = "regular"
}

export enum CompanyTypes {
  restaurant = "restaurant",
  bar = "bar",
  beauty_salon = "beauty_salon",
  barber = "barber",
  hairdresser = "hairdresser",
  cafe = "cafe",
  snackbar = "snackbar",
  spa = "spa",
  massage_salon = "massage_salon",
  hotel = "hotel"
}

export enum CouponAdjustmentTypes {
  percentage = "percentage",
  fixed = "fixed"
}

export enum CouponFilters {
  all_products = "all_products",
  products_in_category = "products_in_category",
  selected_products = "selected_products"
}

export enum CouponTypes {
  buy_x_get_x = "buy_x_get_x",
  buy_x_get_y = "buy_x_get_y",
  cart_adjustment = "cart_adjustment",
  product_adjustment = "product_adjustment",
  free_shipping = "free_shipping",
  bulk = "bulk"
}

export enum DayOfWeek {
  sunday = "sunday",
  monday = "monday",
  tuesday = "tuesday",
  wednesday = "wednesday",
  thursday = "thursday",
  friday = "friday",
  saturday = "saturday"
}

export enum DeliveryAreaTypes {
  radius = "radius",
  zip_code = "zip_code",
  custom = "custom"
}

export enum DeviceConnectionTypes {
  usb = "usb",
  network = "network",
  serial = "serial"
}

export enum DeviceLoginStatus {
  pending = "pending",
  declined = "declined",
  approved = "approved"
}

export enum DeviceStatus {
  online = "online",
  offline = "offline"
}

export enum DeviceTypes {
  printer = "printer",
  handheld = "handheld",
  base_station = "base_station",
  browser = "browser"
}

export enum DiscountTypes {
  fixed = "fixed",
  percentage = "percentage"
}

export enum DocumentType {
  privacy_statement = "privacy_statement",
  terms_and_conditions = "terms_and_conditions",
  sepa = "sepa"
}

export enum EmployeeClockingReportType {
  in = "in",
  out = "out",
  break_start = "break_start",
  break_end = "break_end"
}

export enum EmployeeGroupTypes {
  manager = "manager",
  default = "default",
  custom = "custom"
}

export enum EventStatus {
  expected = "expected",
  pending = "pending",
  hold = "hold",
  no_show = "no_show",
  checked_in = "checked_in",
  checked_out = "checked_out",
  canceled = "canceled",
  expired = "expired"
}

export enum EventType {
  booking_reminder = "booking_reminder",
  booking_review = "booking_review",
  note_reminder = "note_reminder"
}

export enum ExternalServices {
  mollie = "mollie",
  thuisbezorgd = "thuisbezorgd",
  ubereats = "ubereats",
  deliveroo = "deliveroo"
}

export enum FeatureFlags {
  split_bill = "split_bill",
  transfer_table = "transfer_table",
  table_discount = "table_discount",
  order_comment = "order_comment"
}

export enum FeeTypes {
  transaction = "transaction",
  item = "item",
  google_reserve = "google_reserve",
  booking_widget = "booking_widget"
}

export enum FeedbackTypes {
  booking = "booking",
  order = "order"
}

export enum FloorPlanItemBackgroundType {
  solid = "solid",
  gradient = "gradient",
  texture = "texture",
  pattern = "pattern",
  no_fill = "no_fill"
}

export enum FloorPlanItemType {
  plant_1 = "plant_1",
  toilet_1 = "toilet_1",
  kitchen_stove_1 = "kitchen_stove_1",
  wall_1 = "wall_1",
  floor_1 = "floor_1",
  floor_2 = "floor_2",
  floor_3 = "floor_3",
  bar_straight_1 = "bar_straight_1",
  bar_corner_1 = "bar_corner_1",
  bar_block_1 = "bar_block_1",
  custom = "custom",
  door = "door",
  table = "table"
}

export enum FontSizes {
  small = "small",
  medium = "medium",
  large = "large"
}

export enum ImageTypes {
  product = "product",
  product_category = "product_category",
  booking_widget = "booking_widget"
}

export enum LogTypes {
  booking_created_manual = "booking_created_manual",
  booking_created_online = "booking_created_online",
  booking_confirmation_email_sent = "booking_confirmation_email_sent",
  booking_review_email_sent = "booking_review_email_sent",
  booking_reminder_email_sent = "booking_reminder_email_sent",
  booking_status_changed = "booking_status_changed",
  booking_deleted = "booking_deleted",
  booking_imported = "booking_imported",
  booking_recovered = "booking_recovered",
  booking_feedback_received = "booking_feedback_received",
  booking_canceled_by_customer = "booking_canceled_by_customer",
  booking_time_modified_by_customer = "booking_time_modified_by_customer",
  booking_time_modified = "booking_time_modified",
  booking_group_size_modified = "booking_group_size_modified",
  booking_group_size_modified_by_customer = "booking_group_size_modified_by_customer",
  booking_down_payment_received = "booking_down_payment_received",
  order_accepted = "order_accepted",
  special_day_created = "special_day_created",
  special_day_updated = "special_day_updated",
  special_day_deleted = "special_day_deleted"
}

export enum ModifierTypes {
  product = "product",
  comment = "comment",
  price = "price"
}

export enum ModuleTypes {
  cash_register = "cash_register",
  ordering = "ordering",
  booking = "booking",
  table = "table",
  google_reserve_integration = "google_reserve_integration",
  the_fork_integration = "the_fork_integration",
  social_deal_integration = "social_deal_integration",
  just_eat_integration = "just_eat_integration",
  uber_eats_integration = "uber_eats_integration",
  gold_pack = "gold_pack",
  silver_pack = "silver_pack",
  hosted_domain = "hosted_domain",
  platform_access = "platform_access",
  thuisbezorgd_integration = "thuisbezorgd_integration"
}

export enum NotificationChannels {
  email = "email",
  sms = "sms",
  push = "push"
}

export enum NotificationTypes {
  new_order = "new_order",
  new_booking = "new_booking",
  canceled_order = "canceled_order",
  canceled_booking = "canceled_booking",
  updated_booking = "updated_booking",
  employee_sign_in = "employee_sign_in",
  new_booking_request = "new_booking_request"
}

export enum OpeningHourTypes {
  delivery = "delivery",
  pickup = "pickup",
  store = "store"
}

export enum OrderAuditTypes {
  transfer_order = "transfer_order",
  pro_forma_print = "pro_forma_print",
  finallize = "finallize",
  split_order = "split_order",
  create_order = "create_order",
  finalize = "finalize",
  unfinalize = "unfinalize"
}

export enum OrderEditType {
  create = "create",
  add_item = "add_item",
  remove_item = "remove_item",
  delete = "delete",
  receipt = "receipt",
  checkout = "checkout",
  transfer = "transfer",
  visit = "visit"
}

export enum OrderLineAuditTypes {
  create = "create",
  delete = "delete",
  update_price = "update_price",
  update_quantity = "update_quantity",
  transfer = "transfer",
  update = "update",
  order = "order",
  add_comment = "add_comment",
  remove_comment = "remove_comment",
  add_modifier = "add_modifier",
  remove_modifier = "remove_modifier",
  order_discount = "order_discount"
}

export enum OrderLineStatus {
  active = "active",
  removed = "removed"
}

export enum OrderLineTypes {
  product = "product",
  comment = "comment",
  discount = "discount",
  extra = "extra"
}

export enum OrderStatus {
  new = "new",
  accepted = "accepted",
  in_progress = "in_progress",
  canceled = "canceled",
  in_delivery = "in_delivery"
}

export enum OrderTypes {
  delivery = "delivery",
  pickup = "pickup",
  location = "location"
}

export enum PaymentMethodContext {
  in_store = "in_store",
  delivery = "delivery",
  pickup = "pickup",
  booking_widget = "booking_widget"
}

export enum PaymentMethodUsabilityTypes {
  location = "location",
  delivery = "delivery",
  pickup = "pickup"
}

export enum PaymentMethods {
  ideal = "ideal",
  cash = "cash",
  creditcard = "creditcard",
  paypal = "paypal",
  other = "other",
  card = "card",
  t2p = "t2p",
  mollie_t2p = "mollie_t2p"
}

export enum PaymentProcessors {
  mollie = "mollie",
  paynl = "paynl"
}

export enum PaymentStatus {
  paid = "paid",
  pending = "pending",
  canceled = "canceled",
  refunded = "refunded",
  in_progress = "in_progress",
  failed = "failed",
  voided = "voided"
}

export enum Periods {
  always = "always",
  custom = "custom"
}

export enum Permissions {
  view_order = "view_order",
  create_order = "create_order",
  update_order = "update_order",
  delete_order = "delete_order",
  view_booking = "view_booking",
  create_booking = "create_booking",
  update_booking = "update_booking",
  delete_booking = "delete_booking",
  view_product = "view_product",
  create_product = "create_product",
  update_product = "update_product",
  delete_product = "delete_product",
  view_product_category = "view_product_category",
  create_product_category = "create_product_category",
  update_product_category = "update_product_category",
  delete_product_category = "delete_product_category",
  view_employee = "view_employee",
  create_employee = "create_employee",
  update_employee = "update_employee",
  delete_employee = "delete_employee",
  view_employee_group = "view_employee_group",
  create_employee_group = "create_employee_group",
  update_employee_group = "update_employee_group",
  delete_employee_group = "delete_employee_group",
  open_drawer = "open_drawer",
  close_drawer = "close_drawer",
  checkout_order = "checkout_order",
  discount_order = "discount_order",
  delete_item_from_order = "delete_item_from_order",
  update_item_from_order = "update_item_from_order",
  view_settings = "view_settings",
  view_billing = "view_billing",
  view_reports = "view_reports",
  view_table = "view_table",
  create_table = "create_table",
  update_table = "update_table",
  delete_table = "delete_table",
  create_mutation = "create_mutation",
  print = "print",
  create_shift = "create_shift",
  update_shift = "update_shift",
  delete_shift = "delete_shift",
  create_order_chart = "create_order_chart",
  update_order_chart = "update_order_chart",
  delete_order_chart = "delete_order_chart",
  create_price = "create_price",
  update_price = "update_price",
  delete_price = "delete_price",
  create_vat_rate = "create_vat_rate",
  update_vat_rate = "update_vat_rate",
  delete_vat_rate = "delete_vat_rate",
  create_section = "create_section",
  update_section = "update_section",
  delete_section = "delete_section",
  create_print_route = "create_print_route",
  update_print_route = "update_print_route",
  delete_print_route = "delete_print_route",
  create_printer = "create_printer",
  update_printer = "update_printer",
  delete_printer = "delete_printer",
  create_payment_method = "create_payment_method",
  update_payment_method = "update_payment_method",
  delete_payment_method = "delete_payment_method",
  create_button = "create_button",
  update_button = "update_button",
  delete_button = "delete_button",
  transfer_items = "transfer_items",
  void_order = "void_order",
  day_overview = "day_overview",
  credit_order = "credit_order",
  transfer_table = "transfer_table",
  delete_order_line = "delete_order_line",
  create_tab = "create_tab",
  update_tab = "update_tab",
  delete_tab = "delete_tab",
  view_booking_audits = "view_booking_audits",
  view_order_audits = "view_order_audits",
  update_layout = "update_layout",
  create_quick_comment = "create_quick_comment",
  update_quick_comment = "update_quick_comment",
  delete_quick_comment = "delete_quick_comment",
  create_proforma = "create_proforma",
  split_order = "split_order",
  merge_orders = "merge_orders",
  force_finalize_order = "force_finalize_order",
  manual_card_transaction = "manual_card_transaction"
}

export enum PriceType {
  location = "location",
  delivery = "delivery",
  take_away = "take_away"
}

export enum PrintOperations {
  receipt = "receipt",
  preparation_receipt = "preparation_receipt",
  preliminary_receipt = "preliminary_receipt",
  day_report = "day_report",
  mutation = "mutation",
  open_drawer = "open_drawer"
}

export enum PrinterImageMode {
  column = "column",
  raster = "raster"
}

export enum PrinterLanguage {
  esc_pos = "esc_pos",
  star_line = "star_line",
  star_prnt = "star_prnt"
}

export enum PrintingStatus {
  pending = "pending",
  failed = "failed",
  success = "success",
  canceled = "canceled"
}

export enum ProductModifierTypes {
  addition = "addition",
  subtraction = "subtraction"
}

export enum ProductModifierValueType {
  fixed = "fixed",
  percentage = "percentage"
}

export enum ProductTypes {
  product = "product",
  modifier = "modifier"
}

export enum ProductVisibilityTypes {
  location = "location",
  pickup = "pickup",
  delivery = "delivery"
}

export enum Providers {
  thuisbezorgd = "thuisbezorgd",
  allindex = "allindex",
  ubereats = "ubereats",
  deliveroo = "deliveroo",
  other = "other",
  the_fork = "the_fork",
  eet_nu = "eet_nu",
  social_deal = "social_deal",
  google_reserve = "google_reserve",
  widget = "widget"
}

export enum Psp {
  mollie = "mollie",
  pay = "pay",
  other = "other"
}

export enum ReceiptType {
  preparation = "preparation",
  pro_forma = "pro_forma",
  receipt = "receipt",
  x = "x",
  z = "z"
}

export enum RegisterButtonLocation {
  footer = "footer",
  sidebar_right = "sidebar_right",
  floor_plan_footer = "floor_plan_footer",
  calendar_footer = "calendar_footer",
  dashboard_footer = "dashboard_footer",
  dashboard_sidebar = "dashboard_sidebar",
  calendar_sidebar = "calendar_sidebar",
  floor_plan_sidebar = "floor_plan_sidebar",
  register_start = "register_start",
  register_end = "register_end",
  cash_register_desktop_footer = "cash_register_desktop_footer",
  cash_register_mobile_footer = "cash_register_mobile_footer",
  cash_register_desktop_side = "cash_register_desktop_side",
  guest_planning_desktop_footer = "guest_planning_desktop_footer",
  guest_planning_mobile_footer = "guest_planning_mobile_footer",
  guest_planning_desktop_side = "guest_planning_desktop_side",
  table_planning_desktop_footer = "table_planning_desktop_footer",
  table_planning_mobile_footer = "table_planning_mobile_footer",
  table_planning_desktop_side = "table_planning_desktop_side",
  dashboard_desktop_footer = "dashboard_desktop_footer",
  dashboard_mobile_footer = "dashboard_mobile_footer",
  dashboard_desktop_side = "dashboard_desktop_side",
  floor_plan_desktop_footer = "floor_plan_desktop_footer",
  floor_plan_desktop_side = "floor_plan_desktop_side",
  floor_plan_mobile_footer = "floor_plan_mobile_footer",
  order_overview_desktop_footer = "order_overview_desktop_footer",
  order_overview_mobile_footer = "order_overview_mobile_footer",
  order_overview_desktop_side = "order_overview_desktop_side"
}

export enum RegisterFunctions {
  print_preliminary_receipt = "print_preliminary_receipt",
  order = "order",
  checkout = "checkout",
  table_overview = "table_overview",
  open_drawer = "open_drawer",
  misc_product = "misc_product",
  day_overview = "day_overview",
  drawer_mutation = "drawer_mutation",
  close_register = "close_register",
  transfer_table = "transfer_table",
  delete_order = "delete_order",
  order_discount = "order_discount",
  order_comment = "order_comment",
  functions_overview = "functions_overview",
  cancel_operation = "cancel_operation",
  new_booking = "new_booking",
  calendar = "calendar",
  pause_shift = "pause_shift",
  table_next_round = "table_next_round",
  dashboard = "dashboard",
  quick_comment = "quick_comment",
  end_day = "end_day",
  end_shift = "end_shift",
  clock_in = "clock_in",
  clock_out = "clock_out",
  view_open_orders = "view_open_orders",
  guests = "guests",
  tables = "tables",
  initiate_order_transfer = "initiate_order_transfer",
  void_order = "void_order",
  split_order = "split_order",
  logout = "logout",
  transfer_items = "transfer_items",
  direct_sale = "direct_sale",
  order_hold = "order_hold"
}

export enum ShiftRepeat {
  never = "never",
  daily = "daily",
  weekly = "weekly",
  monthly = "monthly"
}

export enum ShiftState {
  blank = "blank",
  recurring = "recurring",
  absent = "absent",
  single = "single",
  override = "override"
}

export enum ShiftType {
  bookings = "bookings",
  delivery = "delivery",
  take_away = "take_away",
  store = "store"
}

export enum States {
  open = "open",
  busy = "busy",
  closed = "closed"
}

export enum Status {
  active = "active",
  inactive = "inactive",
  trashed = "trashed"
}

export enum SubscriptionIntervals {
  month = "month",
  year = "year",
  week = "week",
  once = "once"
}

export enum SubscriptionStatus {
  active = "active",
  not_active = "not_active"
}

export enum SubscriptionType {
  max = "max",
  regular = "regular",
  addon = "addon"
}

export enum SupportedCurrencies {
  EUR = "EUR",
  USD = "USD",
  GBP = "GBP"
}

export enum SupportedIntegrations {
  google_reserve = "google_reserve",
  thuisbezorgd = "thuisbezorgd",
  uber_eats = "uber_eats",
  pay = "pay",
  voys = "voys",
  mollie = "mollie",
  social_deal = "social_deal",
  dining_city = "dining_city",
  snelstart = "snelstart",
  moneybird = "moneybird",
  e_boekhouden = "e_boekhouden",
  exact = "exact",
  yuki = "yuki",
  ccv = "ccv"
}

export enum SupportedLanguages {
  nl = "nl",
  en = "en",
  fr = "fr",
  de = "de"
}

export enum TableIcon {
  four_rectangle = "four_rectangle",
  four_round = "four_round",
  two_rectangle = "two_rectangle",
  two_round = "two_round"
}

export enum TableShapes {
  square = "square",
  round = "round",
  rectangle = "rectangle"
}

export enum TableTypes {
  location = "location",
  take_away = "take_away"
}

export enum TemplateSendType {
  sms = "sms",
  email = "email"
}

export enum TemplateType {
  booking_confirmation = "booking_confirmation",
  booking_pending_confirmation = "booking_pending_confirmation",
  booking_rejection = "booking_rejection",
  booking_reminder = "booking_reminder",
  booking_no_show = "booking_no_show",
  booking_moved = "booking_moved",
  booking_canceled = "booking_canceled",
  booking_digital_invoice = "booking_digital_invoice",
  booking_modified = "booking_modified",
  booking_review = "booking_review"
}

export enum TemplateTypes {
  booking_confirmation = "booking_confirmation",
  booking_canceled = "booking_canceled",
  booking_pending_confirmation = "booking_pending_confirmation",
  booking_moved = "booking_moved",
  booking_digital_invoice = "booking_digital_invoice",
  booking_rejected = "booking_rejected",
  order_confirmation = "order_confirmation",
  order_canceled = "order_canceled",
  order_pending_confirmation = "order_pending_confirmation",
  order_delivered = "order_delivered"
}

export enum TerminalTypes {
  pax_a77 = "pax_a77",
  pax_a920 = "pax_a920",
  mollie_terminal_app = "mollie_terminal_app",
  pay_pos_app = "pay_pos_app"
}

export enum Themes {
  dark = "dark",
  light = "light",
  system = "system"
}

export enum TicketStatus {
  pending = "pending",
  printed = "printed",
  canceled = "canceled"
}

export enum TicketTypes {
  preparation = "preparation",
  pro_forma = "pro_forma",
  receipt = "receipt",
  z_report = "z_report",
  mutation = "mutation"
}

export enum TimeslotType {
  bookings = "bookings",
  delivery = "delivery",
  take_away = "take_away",
  store = "store"
}

export enum TokenGrants {
  booking_widget = "booking_widget",
  read_products = "read_products",
  voys = "voys"
}

export enum UserBranch {
  production = "production",
  staging = "staging",
  testing = "testing",
  training = "training",
  beta = "beta"
}

export enum UserRole {
  user = "user",
  admin = "admin",
  demo = "demo"
}

export enum UserTypes {
  restaurant = "restaurant",
  store = "store",
  hair_salon = "hair_salon",
  beauty_salon = "beauty_salon",
  other = "other",
  snackbar = "snackbar",
  bakery = "bakery"
}

export enum VisibilityTypes {
  local = "local",
  direct = "direct",
  online = "online"
}

export enum WidgetMessageType {
  session = "session",
  cookie = "cookie"
}